export enum Action {
  Rent,
  Sale,
}
